export enum MonitoringBomServiceId {
  PROJECT_MANAGEMENT = "projectManagement",
  CONSULTING = "consulting",
  TRAINING = "training",
  INSTALLATION_COMMISSIONING = "installationCommissioning",
}

export interface MonitoringBomServiceDefinition {
  id: MonitoringBomServiceId;
  label: () => string;
  partNumber: string;
}

export const MONITORING_BOM_SERVICE_DEFINITIONS: MonitoringBomServiceDefinition[] = [
  {
    id: MonitoringBomServiceId.PROJECT_MANAGEMENT,
    label: () => $localize`:@@monitoring.productList.services.projectManagement:Project Management`,
    partNumber: "MS90003",
  },
  {
    id: MonitoringBomServiceId.CONSULTING,
    label: () => $localize`:@@monitoring.productList.services.consulting:Consulting`,
    partNumber: "MS90006",
  },
  {
    id: MonitoringBomServiceId.TRAINING,
    label: () => $localize`:@@monitoring.productList.services.training:Training`,
    partNumber: "MS90005",
  },
  {
    id: MonitoringBomServiceId.INSTALLATION_COMMISSIONING,
    label: () => $localize`:@@monitoring.productList.services.installationCommissioning:Installation/Commissioning`,
    partNumber: "MS90004",
  },
];

export function getMonitoringBomServiceDefinition(id: MonitoringBomServiceId): MonitoringBomServiceDefinition {
  const definition = MONITORING_BOM_SERVICE_DEFINITIONS.find((entry) => entry.id === id);
  if (!definition) {
    throw new Error(`Unknown monitoring BOM service: ${id}`);
  }
  return definition;
}
